import { render, staticRenderFns } from "./iconDate.vue?vue&type=template&id=58b53fa9"
import script from "./iconDate.vue?vue&type=script&lang=js"
export * from "./iconDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports